
import { defineComponent } from 'vue'
import CompanyList from '@/components/companies/CompanyList.vue'

export default defineComponent({
  components: {
    CompanyList,
  },
})
